import { useLocalStorage } from 'usehooks-ts';

import { FailedPage } from '@/components/FailedPage';

import { LS_USER_BLOCKED_AT_PATH } from '@/constants/common';
import { ROUTE } from '@/constants/routes';

import { useAppDispatch } from '@/hooks/redux';
import { useResponsive } from '@/hooks/useResponsive';

import { signOut } from '@/redux/auth/actions';

export function NonResidentMinorRejectedPage() {
  const dispatch = useAppDispatch();
  const { isMobile } = useResponsive();
  const [, setUserBlockedPath] = useLocalStorage(LS_USER_BLOCKED_AT_PATH, '');

  const onMount = () => {
    setUserBlockedPath(ROUTE.NON_RESIDENT_MINOR_REJECTED);
  };

  const onAction = () => {
    dispatch(signOut());
  };

  return (
    <FailedPage
      translationPrefix="nonResidentMinorRejected"
      onAction={onAction}
      testIdPrefix="non-resident-minor-rejected-page"
      onMount={onMount}
      showTitle={false}
      bodyProps={{
        width: '100%',
        textAlign: isMobile ? 'center' : 'left',
      }}
      buttonProps={{ variant: isMobile ? 'text' : 'contained' }}
    />
  );
}

export default NonResidentMinorRejectedPage;
